import { handleActions, createAction } from 'redux-actions';

export const SET_MODAL = createAction('SET/MODAL');
export const TOGGLE_MODAL = createAction('TOGGLE/MODAL');

const initialState = {
  isVisible: null,
  overlayClosesModal: null,
  isCloseButtonShown: null,
  componentName: null,
  customContentClass: '',
  modalTmpData: {},
};

const Modal = handleActions(
  {
    [SET_MODAL]: (state, {
      payload: {
        overlayClosesModal = true,
        isCloseButtonShown = true,
        componentName,
        customContentClass,
        initialData,
      },
    }) => {
      return {
        isVisible: true,
        overlayClosesModal,
        isCloseButtonShown,
        componentName,
        customContentClass,
        modalTmpData: initialData,
      };
    },
    [TOGGLE_MODAL]: (state, { payload: { value, }, }) => {
      return { ...state, isVisible: value, };
    },
  },
  initialState
);

export default Modal;
